/**
 * 前台路由：由模块注册表合成，不含任何具体模块的页面引用。
 *
 * 布局分工：
 *   - `PortalLayout` 承载顶部导航、内容区和公司页脚
 *   - 登录与状态页面使用同一视觉规则的 `StandaloneLayout`
 */

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import PortalLayout from './PortalLayout.vue'
import { defaultLandingPath, sortedModules } from './module-registry'

/** 模块路由：把每个模块的 `routes` 挂到其 `basePath` 下。 */
function moduleRoutes(): RouteRecordRaw[] {
  return sortedModules().map((mod) => ({
    path: mod.basePath,
    component: PortalLayout,
    meta: { moduleKey: mod.key, requiresAuth: mod.requiresAuth ?? false },
    children: mod.routes,
  }))
}

const routes: RouteRecordRaw[] = [
  // 根路径落到首个模块；无模块时进占位页
  {
    path: '/',
    redirect: () => defaultLandingPath() ?? '/placeholder',
  },
  {
    path: '/login',
    name: 'portal-login',
    component: () => import('@/shell/LoginPage.vue'),
    meta: { public: true },
  },
  {
    path: '/admin-entry',
    name: 'portal-admin-entry',
    component: () => import('@/shell/AdminEntryPage.vue'),
    meta: { public: true },
  },
  {
    path: '/placeholder',
    name: 'portal-placeholder',
    component: () => import('@/shell/EmptyPortal.vue'),
    meta: { public: true },
  },
  ...moduleRoutes(),
  {
    path: '/:pathMatch(.*)*',
    name: 'portal-not-found',
    component: () => import('@/shell/NotFoundPage.vue'),
    meta: { public: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return {
      el: to.hash,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    }
    return { top: 0 }
  },
})
